import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as categories from 'catalog/actions/categories'
import { ListGroupItem, Button } from 'reactstrap'
import SubCategoryList from 'catalog/containers/SubCategoryList'
import autobind from 'autobind-decorator'

@connect(
    state => ({
        activeCategory: state.categories.activeCategory
    }),
    dispatch => ({
        chooseCategory: (category) => dispatch(categories.chooseCategory(category)),
        unchooseCategory: (category) => dispatch(categories.unchooseCategory(category))
    })
)
export default class Category extends Component {

    @autobind
    chooseCategory() {
        const { category } = this.props
        if (this.isActive()) {
            this.props.unchooseCategory(!!category.parent);
        } else {
            this.props.chooseCategory(category);
        }
    }

    @autobind
    isActive() {
        const { category, activeCategory } = this.props
        return !!activeCategory && category.id === activeCategory.id
    }

    render() {
        const { index, category } = this.props;
        const indexOffset = 1;
        return (

            <ListGroupItem>
                <Button
                    color={'link'}
                    onClick={this.chooseCategory}
                >
                    {index + indexOffset}. {category.name}
                </Button>
                {
                    this.isActive() &&
                    <SubCategoryList />
                }
            </ListGroupItem>
        )
    }
}